"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const debounce_1 = __importDefault(require("lodash/debounce"));
const react_1 = require("react");
const FormikOnChange = (props) => {
    const { onChange = () => null, enableValidation = true, enableOnload = false, debounceTime = 0, } = props;
    const { values, errors, setTouched, initialValues } = (0, formik_1.useFormikContext)();
    const previousValuesRef = (0, react_1.useRef)(enableOnload ? {} : initialValues);
    const debounceOnChange = (0, react_1.useRef)((0, debounce_1.default)((value) => {
        onChange(value);
    }, debounceTime));
    (0, react_1.useEffect)(() => {
        const isChanged = JSON.stringify(previousValuesRef.current) !== JSON.stringify(values);
        if (isChanged) {
            if (enableValidation) {
                if (Object.keys(errors).length === 0 && isChanged) {
                    debounceOnChange.current(values);
                }
                else {
                    void setTouched(errors);
                }
            }
            else {
                debounceOnChange.current(values);
            }
        }
        previousValuesRef.current = values;
    }, [values, enableValidation, errors, onChange, setTouched, initialValues]);
    return null;
};
exports.default = (0, react_1.memo)(FormikOnChange);
